import React from "react";
import {
	TouchableOpacity,
	StyleSheet,
} from "react-native";
import noop from "noop3";

import Style from "ae-style";
import StyledIcon from "./StyledIcon";

import { useIdPrefix } from "@aetonix/hooks";

const sizes = Style.text;

const sizeNames = Object.keys(sizes);

const styles = StyleSheet.create({
	button: {
		margin: Style.layout.marginSmall / 2,
		overflow: "visible"
	}
});

export default function StyledIconButton(props){
	const idPrefix = useIdPrefix();
	let onPress = props.onPress;
	const icon = props.icon;
	const contrast = props.contrast;
	const disabled = props.disabled;
	const children = props.children;

	const iconColor = props.color;
	const color = {};
	color[iconColor] = true;

	const styleList = [styles.button];

	const iconStyle = props.iconStyle;

	if(disabled)
		onPress = noop;

	styleList.push(props.style);

	const iconSize = sizeNames.reduce(function(found, name){
		if(found) return found;
		if(props[name]) return name;
		return null;
	}, null) || "large";

	const sizeProps = {};
	sizeProps[iconSize] = true;

	return (
		<TouchableOpacity testID={`${idPrefix}${idPrefix ? "-" : ""}${props.id}`} accessibilityComponentType="button" onPress={onPress} style={styleList}>
			<StyledIcon disabled={disabled} contrast={contrast} name={icon} {...sizeProps} {...color} style={iconStyle} />
			{children}
		</TouchableOpacity>
	);
}